// extracted by mini-css-extract-plugin
module.exports = {"chip":"ApplicationDeadline_chip__ulaQk"};